export function UncheckedIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="deselect-button--radio-button-deselect-empty-ui-interface-uncheck">
        <path id="Vector" d="M9.99999 18.5697C14.7331 18.5697 18.57 14.7328 18.57 9.99969C18.57 5.26661 14.7331 1.42969 9.99999 1.42969C5.26691 1.42969 1.42999 5.26661 1.42999 9.99969C1.42999 14.7328 5.26691 18.5697 9.99999 18.5697Z" stroke="black" strokeOpacity="0.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

export function CheckedIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check-circle--checkmark-addition-circle-success-check-validation-add-form-tick">
        <path id="Subtract" fillRule="evenodd" clipRule="evenodd" d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM13.5036 6.70953C13.8362 6.29366 13.7688 5.68686 13.3529 5.35416C12.9371 5.02147 12.3303 5.0889 11.9976 5.50476L7.43859 11.2035L5.61486 9.83571C5.18881 9.51618 4.58439 9.60252 4.26486 10.0286C3.94533 10.4546 4.03167 11.059 4.45771 11.3786L7.02914 13.3071C7.44582 13.6197 8.03534 13.5447 8.3607 13.1381L13.5036 6.70953Z" fill="#2E6AFF" />
      </g>
    </svg>

  );
}
